// extracted by mini-css-extract-plugin
export default {"base":"Item_base__C8naY","active":"Item_active__NoUe1","testDiv":"Item_testDiv__r72uC"};